import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const HojasQuirurgicasReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(Types.CONSULTAR_PACIENTE_LOADING, (state) => {
      state.consultarPacienteLoading = true;
      state.consultarPacienteError = null;
    })
    .addCase(Types.CONSULTAR_PACIENTE_SUCCESS, (state, action) => {
      const { consultarPacienteData } = action;
      state.consultarPacienteData = consultarPacienteData;
      state.consultarPacienteLoading = false;
      state.consultarPacienteError = null;
    })
    .addCase(Types.CONSULTAR_PACIENTE_FAILURE, (state, action) => {
      const { consultarPacienteError } = action;
      state.consultarPacienteData = INITIAL_STATE.consultarPacienteData;
      state.consultarPacienteLoading = false;
      state.consultarPacienteError = consultarPacienteError;
    });

  builder
    .addCase(Types.CONSULTAR_PACIENTES_LOADING, (state) => {
      state.consultarPacientesLoading = true;
      state.consultarPacientesError = null;
    })
    .addCase(Types.CONSULTAR_PACIENTES_SUCCESS, (state, action) => {
      const { consultarPacientesData } = action;
      state.consultarPacientesData = consultarPacientesData;
      state.consultarPacientesLoading = false;
      state.consultarPacientesError = null;
    })
    .addCase(Types.CONSULTAR_PACIENTES_FAILURE, (state, action) => {
      const { consultarPacientesError } = action;
      state.consultarPacientesData = INITIAL_STATE.consultarPacientesData;
      state.consultarPacientesLoading = false;
      state.consultarPacientesError = consultarPacientesError;
    });

  builder
    .addCase(Types.VALIDAR_HOJA_QUIRURGICA_LOADING, (state) => {
      state.validarHojaQuirurgicaLoading = true;
      state.validarHojaQuirurgicaError = null;
    })
    .addCase(Types.VALIDAR_HOJA_QUIRURGICA_SUCCESS, (state, action) => {
      const { validarHojaQuirurgicaData } = action;
      state.validarHojaQuirurgicaData = validarHojaQuirurgicaData;
      state.validarHojaQuirurgicaLoading = false;
      state.validarHojaQuirurgicaError = null;
    })
    .addCase(Types.VALIDAR_HOJA_QUIRURGICA_FAILURE, (state, action) => {
      const { validarHojaQuirurgicaError } = action;
      state.validarHojaQuirurgicaData = INITIAL_STATE.validarHojaQuirurgicaData;
      state.validarHojaQuirurgicaLoading = false;
      state.validarHojaQuirurgicaError = validarHojaQuirurgicaError;
    });

  builder
    .addCase(Types.CONSULTAR_ESTATUS_HOJAS_QX_LOADING, (state) => {
      state.consultarEstatusHojasQXLoading = true;
      state.consultarEstatusHojasQXError = null;
    })
    .addCase(Types.CONSULTAR_ESTATUS_HOJAS_QX_SUCCESS, (state, action) => {
      const { consultarEstatusHojasQXData } = action;
      state.consultarEstatusHojasQXData = consultarEstatusHojasQXData;
      state.consultarEstatusHojasQXLoading = false;
      state.consultarEstatusHojasQXError = null;
    })
    .addCase(Types.CONSULTAR_ESTATUS_HOJAS_QX_FAILURE, (state, action) => {
      const { consultarEstatusHojasQXError } = action;
      state.consultarEstatusHojasQXData = INITIAL_STATE.consultarEstatusHojasQXData;
      state.consultarEstatusHojasQXLoading = false;
      state.consultarEstatusHojasQXError = consultarEstatusHojasQXError;
    });

  builder
    .addCase(Types.REGISTRAR_COBERTURA_LOADING, (state) => {
      state.registrarCoberturaLoading = true;
      state.registrarCoberturaError = null;
    })
    .addCase(Types.REGISTRAR_COBERTURA_SUCCESS, (state, action) => {
      const { registrarCoberturaData } = action;
      state.registrarCoberturaData = registrarCoberturaData;
      state.registrarCoberturaLoading = false;
      state.registrarCoberturaError = null;
    })
    .addCase(Types.REGISTRAR_COBERTURA_FAILURE, (state, action) => {
      const { registrarCoberturaError } = action;
      state.registrarCoberturaData = INITIAL_STATE.registrarCoberturaData;
      state.registrarCoberturaLoading = false;
      state.registrarCoberturaError = registrarCoberturaError;
    });

  builder
    .addCase(Types.CONSULTAR_DETALLE_ANEXOS_LOADING, (state) => {
      state.consultarDetalleAnexosLoading = true;
      state.consultarDetalleAnexosError = null;
    })
    .addCase(Types.CONSULTAR_DETALLE_ANEXOS_SUCCESS, (state, action) => {
      const { consultarDetalleAnexosData } = action;
      state.consultarDetalleAnexosData = consultarDetalleAnexosData;
      state.consultarDetalleAnexosLoading = false;
      state.consultarDetalleAnexosError = null;
    })
    .addCase(Types.CONSULTAR_DETALLE_ANEXOS_FAILURE, (state, action) => {
      const { consultarDetalleAnexosError } = action;
      state.consultarDetalleAnexosData = INITIAL_STATE.consultarDetalleAnexosData;
      state.consultarDetalleAnexosLoading = false;
      state.consultarDetalleAnexosError = consultarDetalleAnexosError;
    });

  builder
    .addCase(Types.CONSULTAR_DETALLE_COBERTURA_LOADING, (state) => {
      state.consultarDetalleCoberturaLoading = true;
      state.consultarDetalleCoberturaError = null;
    })
    .addCase(Types.CONSULTAR_DETALLE_COBERTURA_SUCCESS, (state, action) => {
      const { consultarDetalleCoberturaData } = action;
      state.consultarDetalleCoberturaData = consultarDetalleCoberturaData;
      state.consultarDetalleCoberturaLoading = false;
      state.consultarDetalleCoberturaError = null;
    })
    .addCase(Types.CONSULTAR_DETALLE_COBERTURA_FAILURE, (state, action) => {
      const { consultarDetalleCoberturaError } = action;
      state.consultarDetalleCoberturaData = INITIAL_STATE.consultarDetalleCoberturaData;
      state.consultarDetalleCoberturaLoading = false;
      state.consultarDetalleCoberturaError = consultarDetalleCoberturaError;
    });
});
